(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    document.querySelectorAll('[data-cchef-catfilter]').forEach(setup);
  }

  function setup(root) {
    var chips = root.querySelectorAll('[data-cchef-cat-chip]');
    var catalog = document.querySelector(root.getAttribute('data-catalog-target'));
    if (!catalog) return;
    var cards = catalog.querySelectorAll('[data-cchef-card]');
    var emptyMsg = catalog.querySelector('[data-cchef-catalog-empty]');

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var category = chip.getAttribute('data-category');
        chips.forEach(function (c) {
          c.setAttribute('data-active', 'false');
        });
        chip.setAttribute('data-active', 'true');

        var visibleCount = 0;
        cards.forEach(function (card) {
          var matches = category === 'all' || card.getAttribute('data-category') === category;
          card.style.display = matches ? '' : 'none';
          if (matches) visibleCount++;
        });

        if (emptyMsg) emptyMsg.hidden = visibleCount !== 0;

        catalog.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
})();
